import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  allNotifications: {},
  loading: false,
  error: null,
};

const getNotificationSlice = createSlice({
  name: "getNotification",
  initialState,
  reducers: {
    fetchGetNotificationSuccess: (state, action) => {
      state.loading = false;
      state.allNotifications = action.payload;
    },
    fetchGetNotificationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchGetNotificationSuccess, fetchGetNotificationFailure } =
  getNotificationSlice.actions;

export default getNotificationSlice.reducer;
